import {NgModule} from '@angular/core';

import {ModalExitComponent} from './modal-exit.component';
import {MatIconModule} from "@angular/material/icon";

import {MatDividerModule} from "@angular/material/divider";
import {MatDialogModule} from "@angular/material/dialog";
import {TranslocoModule} from "@ngneat/transloco";


@NgModule({

  exports: [ModalExitComponent],
  declarations: [ModalExitComponent],

  imports: [
    MatIconModule,
    MatDividerModule,
    MatDialogModule,
TranslocoModule
  ]
})
export class ModalExitModule {
}

